/*
 *   File : add-field.js
 *   Author : https://evoqins.com
 *   Description :Delete confirm modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { RadioGroup } from '../FormElements';
import { APIService } from '../../Service';

const RADIO_OPTIONS = [
    { value: 'option1', label: 'Mandatory' },
    { value: 'option2', label: 'Optional' },
    { value: 'option3', label: 'Nil' },
];

const AddFieldConfigModal = ({ fieldData, handleClose, onUpdate, corridorId, channelId }) => {

    const [selected, setSelected] = useState(RADIO_OPTIONS[0].value);
    const [loading, setLoading] = useState(false);
    const [editStatus, setEditStatus] = useState(false);

    useEffect(() => {
        var edit_modal = document.getElementById("add-field-config-modal");
        edit_modal.addEventListener("hidden.bs.modal", () => {
            setEditStatus(false);
        });
    }, []);

    useEffect(() => {
        if (fieldData) {
            const priority = (fieldData.priority || "").toLowerCase();
            if (priority === "mandatory") setSelected("option1");
            else if (priority === "optional") setSelected("option2");
            else setSelected("option3");
        }
    }, [fieldData]);

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("add-field-config-modal-close");
        button.click();
        setEditStatus(false);
        handleClose();
    };

    // API - add field 
    const _handleAddField = () => {
        setLoading(true);
        let is_post = true;
        let url = 'field-mapping/add';
        let data = {
            master_id: fieldData.master_id,
            corridor_id: corridorId,
            channel_id: channelId,
            mandatory: selected === 'option1',
            optional: selected === 'option2',
            nill: selected === 'option3'

        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
                _handleCloseModal();
                onUpdate();
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoading(false);
        });
    };


    return (
        <div className="modal fade" id="add-field-config-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered ">
                <div className="modal-content e-border-radius-28 w-400px mx-auto ">
                    <img src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className='d-none'
                        id='add-field-config-modal-close'
                        alt='close'
                        data-bs-dismiss="modal" />
                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">


                        <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
                            Add Field
                        </h4>
                        <img src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt='close'
                            className='cursor-pointer'
                            onClick={_handleCloseModal} />

                    </div>
                    <div className="modal-body px-4 pb-2 pt-0">
                        <>
                            <RadioGroup label="Mandatory/Optional"
                                labelStyle="e-font-weight-400"
                                data={RADIO_OPTIONS}
                                selectedItem={selected}
                                onSelectItem={(value) => setSelected(value)}
                            />

                            {/* Custom button  */}
                            <div className='row row-cols-2 pt-2 mt-2 pb-3'>
                                <div className='col'>
                                    <SecondaryButton name="Cancel"
                                        className="w-100"
                                        onPress={_handleCloseModal} />
                                </div>
                                <div className='col'>
                                    <PrimaryButton name="Create"
                                        className="w-100 e-bg-primary-blue"
                                        status={loading}
                                        onPress={_handleAddField}
                                    />
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>

    )
}

AddFieldConfigModal.defaultProps = {
    handleClose: () => { }
}

export default memo(AddFieldConfigModal);